.order-details-section-title {
  color: var(--default--text-color--17);
}
